import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { INDUSTRIES, INDUSTRY_CHALLENGES } from "../data/mockData";
import Icon from "../components/common/Icon";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

const Industries = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="bg-slate-900 text-white pt-36 pb-20 relative">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=1600&q=80')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <span className="text-gold font-bold uppercase tracking-widest text-sm mb-2 block">Sectors</span>
          <h1 className="text-5xl font-display font-bold uppercase tracking-wide mb-4">Industries Served</h1>
          <p className="text-xl text-gray-300 max-w-2xl font-light">
            Deep expertise across the core industrial sectors.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        {/* Industries grid */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {INDUSTRIES.map((ind, idx) => (
                <div key={idx} className="group border border-gray-100 p-8 shadow-sm hover:shadow-xl transition-all duration-300 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-all group-hover:bg-gold/10"></div>
                  <div className="flex items-start gap-6">
                    <div className="p-4 bg-primary text-white rounded-sm shrink-0">
                      <Icon name={ind.icon} size={32} />
                    </div>
                    <div>
                      <h3 className="text-2xl font-display font-bold text-foreground mb-4">{ind.name}</h3>
                      <p className="text-gray-600 mb-6 leading-relaxed">
                        We provide specialized solutions for the {ind.name.toLowerCase()} sector, focusing on operational efficiency, safety compliance, and asset longevity.
                      </p>
                      <ul className="space-y-2 mb-6">
                        <li className="flex items-center gap-2 text-sm text-gray-500">
                          <span className="h-1.5 w-1.5 bg-gold rounded-full"></span> Specialized Maintenance
                        </li>
                        <li className="flex items-center gap-2 text-sm text-gray-500">
                          <span className="h-1.5 w-1.5 bg-gold rounded-full"></span> Process Optimization
                        </li>
                      </ul>
                      <Button variant="link" className="p-0 text-primary uppercase tracking-wider font-bold" asChild>
                        <Link to="/contact">Discuss Your Project</Link>
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Challenges & Solutions */}
        <section className="py-24 bg-gray-50" data-testid="challenges-section">
          <div className="container mx-auto px-4">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <span className="text-gold font-bold uppercase tracking-widest text-sm mb-2 block">The Yantraksh Advantage</span>
              <h2 className="text-4xl font-display font-bold text-foreground mb-4">Industry Challenges & Solutions</h2>
              <div className="h-1 w-24 bg-gold mx-auto"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {INDUSTRY_CHALLENGES.map((item, idx) => (
                <div key={idx} className="bg-white border border-gray-100 shadow-sm overflow-hidden">
                  <div className="bg-slate-900 text-white px-6 py-4">
                    <span className="text-xs uppercase tracking-widest text-gold font-bold">Challenge</span>
                    <p className="font-display font-bold text-lg">{item.challenge}</p>
                  </div>
                  <div className="px-6 py-5 flex items-start gap-3">
                    <ArrowRight className="text-gold mt-1 shrink-0" size={20} />
                    <div>
                      <span className="text-xs uppercase tracking-widest text-primary font-bold">Our Solution</span>
                      <p className="text-gray-700">{item.solution}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Industries;
